import script from "./VInlineLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInlineLink.vue?vue&type=script&setup=true&lang=ts"

import "./VInlineLink.vue?vue&type=style&index=0&id=1155e4c6&lang=scss"

const __exports__ = script;

export default __exports__